import { Link } from '@mui/material';
import { Box, Typography } from 'hephaestus/web';

type HouseholdModelPortfolioDetailFieldProps = {
  label: string;
  value: string;
  href?: string;
  testId?: string;
};

export const HouseholdModelPortfolioDetailField = ({
  label,
  value,
  href,
  testId,
}: HouseholdModelPortfolioDetailFieldProps) => (
  <Box
    data-testid={testId ?? `household-model-portfolio-detail-field-${label}`}
  >
    <Typography
      variant='bodySmall'
      component='div'
      color='textSecondary'
      sx={{ mb: 0.5 }}
    >
      {label}
    </Typography>
    {href ? (
      <Link
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        underline='hover'
      >
        <Typography
          variant='bodyMedium'
          sx={{ fontWeight: 500 }}
          component='span'
        >
          {value}
        </Typography>
      </Link>
    ) : (
      <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
        {value}
      </Typography>
    )}
  </Box>
);
